/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    BulkDeleteDocumentsRequest,
    BulkDeleteDocumentsResponse,
    BulkEditDocumentClassificationRequest,
    BulkEditDocumentClassificationResponse,
    BulkShareBuildingDocumentsRequest,
    CreateDocumentRequest,
    CreateDocumentShareLinkResponse,
    CreateDocumentsResponse,
    CustomerDocumentFolderTreeResponse,
    DocumentExportStatusResponse,
    DocumentImportAcceptedResponse,
    DocumentImportRequest,
    DocumentListResponse,
    DocumentProcessingReceiptSummaryResponse,
    EditDocumentRequest,
    EditDocumentResponse,
    GetBuildingDocumentIntelligenceParams,
    GetBuildingDocumentProcessingReceiptByIdParams,
    GetBuildingDocumentStorageUsageResponse,
    GetDocumentIntelligenceResponse,
    GetDocumentProcessingReceiptResponse,
    GetDocumentViewUrlResponse,
    GetProcoreOauthCallbackParams,
    ListBuildingDocumentProcessingReceiptsParams,
    ListBuildingDocumentProcoreConnectionCompanyProjectDocumentsParams,
    ListBuildingDocumentsParams,
    ListProcoreCompaniesResponse,
    ListProcoreDocumentsResponse,
    ListProcoreProjectsResponse,
    LocalArchiveImportRequest,
    ProcoreConnectionStatusResponse,
    RecipientBatchResponseOfBulkShareBuildingDocumentsResponse,
    RecipientBatchResponseOfShareBuildingDocumentResponse,
    SearchDocumentsRequest,
    SearchDocumentsResponse,
    ShareBuildingDocumentRequest,
    StartDocumentExportResponse,
    StartProcoreAuthorizationRequest,
    StartProcoreAuthorizationResponse,
    StartSelectedDocumentExportRequest,
    UpdateDocumentPrivacyRequest,
    UpdateDocumentPrivacyResponse,
} from '../core-models';

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<
              string,
              string | number | boolean | Array<string | number | boolean>
          >;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue =
    | string
    | number
    | boolean
    | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys?: ReadonlySet<string>,
    preserveRequiredNullables?: false,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValue>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: true,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: boolean | undefined,
    passthroughKeys: ReadonlySet<string>
): Record<string, unknown>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> = new Set(),
    preserveRequiredNullables = false,
    passthroughKeys: ReadonlySet<string> = new Set()
): Record<string, unknown> {
    const filteredParams: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (passthroughKeys.has(key)) {
            if (value !== undefined) {
                filteredParams[key] = value;
            }
            continue;
        }
        if (Array.isArray(value)) {
            const filtered = value.filter(
                (item) =>
                    item != null &&
                    (typeof item === 'string' ||
                        typeof item === 'number' ||
                        typeof item === 'boolean')
            ) as Array<string | number | boolean>;
            if (filtered.length) {
                filteredParams[key] = filtered;
            }
        } else if (value === null && requiredNullableKeys.has(key)) {
            // With a paramsSerializer (preserveRequiredNullables) the literal null
            // is passed through for it to consume; without one, emit an empty
            // string so the required key still reaches the wire as `?key=`
            // instead of being silently dropped. See #3712.
            filteredParams[key] = preserveRequiredNullables ? null : '';
        } else if (
            value != null &&
            (typeof value === 'string' ||
                typeof value === 'number' ||
                typeof value === 'boolean')
        ) {
            filteredParams[key] = value;
        }
    }
    return filteredParams;
}

@Injectable({ providedIn: 'root' })
export class BuildingDocumentsApiService {
    private readonly http = inject(HttpClient);
    /**
     * Queues an export from the exact active document set currently visible to the authenticated requester.
     * @summary Start a building document export
     */
    createBuildingDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-exports`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/document-exports`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/document-exports`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns canonical export status for the owning requester.
     * @summary Get building document export status
     */
    getBuildingDocumentExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        jobId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        jobId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        jobId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentExportById<TData = DocumentExportStatusResponse>(
        buildingId: string,
        jobId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-exports/${jobId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-exports/${jobId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-exports/${jobId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Rechecks current access and requester ownership, then redirects to a fresh short-lived private archive read URL.
     * @summary Download a completed building document export
     */
    getBuildingDocumentExportDownload<TData = unknown>(
        buildingId: string,
        jobId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentExportDownload<TData = unknown>(
        buildingId: string,
        jobId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentExportDownload<TData = unknown>(
        buildingId: string,
        jobId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentExportDownload<TData = unknown>(
        buildingId: string,
        jobId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-exports/${jobId}/download`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-exports/${jobId}/download`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-exports/${jobId}/download`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns recent durable batch summaries newest first. All outcomes and counts are recomputed using the caller's current document visibility.
     * @summary List recent document processing receipts
     */
    listBuildingDocumentProcessingReceipts<
        TData = DocumentProcessingReceiptSummaryResponse[],
    >(
        buildingId: string,
        params: ListBuildingDocumentProcessingReceiptsParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentProcessingReceipts<
        TData = DocumentProcessingReceiptSummaryResponse[],
    >(
        buildingId: string,
        params: ListBuildingDocumentProcessingReceiptsParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentProcessingReceipts<
        TData = DocumentProcessingReceiptSummaryResponse[],
    >(
        buildingId: string,
        params: ListBuildingDocumentProcessingReceiptsParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentProcessingReceipts<
        TData = DocumentProcessingReceiptSummaryResponse[],
    >(
        buildingId: string,
        params: ListBuildingDocumentProcessingReceiptsParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-processing-receipts`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-processing-receipts`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-processing-receipts`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Returns the durable terminal classification and intelligence outcome for one upload batch. Items and extracted values are filtered using the caller's current building access.
     * @summary Get a document processing receipt
     */
    getBuildingDocumentProcessingReceiptById<
        TData = GetDocumentProcessingReceiptResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: GetBuildingDocumentProcessingReceiptByIdParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentProcessingReceiptById<
        TData = GetDocumentProcessingReceiptResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: GetBuildingDocumentProcessingReceiptByIdParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentProcessingReceiptById<
        TData = GetDocumentProcessingReceiptResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: GetBuildingDocumentProcessingReceiptByIdParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentProcessingReceiptById<
        TData = GetDocumentProcessingReceiptResponse,
    >(
        buildingId: string,
        batchId: string,
        params?: GetBuildingDocumentProcessingReceiptByIdParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-processing-receipts/${batchId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-processing-receipts/${batchId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-processing-receipts/${batchId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Returns the active original-document bytes and effective upload limit used by document storage enforcement.
     * @summary Get building document storage usage
     */
    getBuildingDocumentStorageUsage<
        TData = GetBuildingDocumentStorageUsageResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    getBuildingDocumentStorageUsage<
        TData = GetBuildingDocumentStorageUsageResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentStorageUsage<
        TData = GetBuildingDocumentStorageUsageResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentStorageUsage<
        TData = GetBuildingDocumentStorageUsageResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-storage-usage`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/document-storage-usage`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/document-storage-usage`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Hard-deletes an explicit set of active building documents and attempts blob cleanup. The database operation is atomic; if any requested document cannot be resolved, viewed by the caller, or deleted because it is ESM evidence, no documents are deleted.
     * @summary Bulk delete documents
     */
    removeBuildingDocuments<TData = BulkDeleteDocumentsResponse>(
        buildingId: string,
        bulkDeleteDocumentsRequest: BulkDeleteDocumentsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingDocuments<TData = BulkDeleteDocumentsResponse>(
        buildingId: string,
        bulkDeleteDocumentsRequest: BulkDeleteDocumentsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingDocuments<TData = BulkDeleteDocumentsResponse>(
        buildingId: string,
        bulkDeleteDocumentsRequest: BulkDeleteDocumentsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingDocuments<TData = BulkDeleteDocumentsResponse>(
        buildingId: string,
        bulkDeleteDocumentsRequest: BulkDeleteDocumentsRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/documents`,
                {
                    body: bulkDeleteDocumentsRequest,
                    ...{
                        ...(options as Omit<
                            NonNullable<typeof options>,
                            'observe'
                        >),
                        observe: 'events',
                    },
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/documents`,
                {
                    body: bulkDeleteDocumentsRequest,
                    ...{
                        ...(options as Omit<
                            NonNullable<typeof options>,
                            'observe'
                        >),
                        observe: 'response',
                    },
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/documents`,
            {
                body: bulkDeleteDocumentsRequest,
                ...{
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'body',
                },
            }
        );
    }
    /**
     * Retrieves a paginated list of active documents.
     * @summary List documents
     */
    listBuildingDocuments<TData = DocumentListResponse>(
        buildingId: string,
        params: ListBuildingDocumentsParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocuments<TData = DocumentListResponse>(
        buildingId: string,
        params: ListBuildingDocumentsParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocuments<TData = DocumentListResponse>(
        buildingId: string,
        params: ListBuildingDocumentsParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocuments<TData = DocumentListResponse>(
        buildingId: string,
        params: ListBuildingDocumentsParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Uploads up to 250 documents and returns per-file results, including duplicates and invalid files.
     * @summary Upload documents
     */
    createBuildingDocument<TData = CreateDocumentsResponse>(
        buildingId: string,
        createDocumentRequest: CreateDocumentRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocument<TData = CreateDocumentsResponse>(
        buildingId: string,
        createDocumentRequest: CreateDocumentRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocument<TData = CreateDocumentsResponse>(
        buildingId: string,
        createDocumentRequest: CreateDocumentRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocument<TData = CreateDocumentsResponse>(
        buildingId: string,
        createDocumentRequest: CreateDocumentRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const formData = new FormData();
        createDocumentRequest.files.forEach((value) =>
            formData.append(`files`, value)
        );
        if (
            createDocumentRequest.requestId !== undefined &&
            createDocumentRequest.requestId !== null
        ) {
            formData.append(`requestId`, createDocumentRequest.requestId);
        }

        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents`,
            formData,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Updates the classification for an explicit set of active building documents. The operation is atomic; if any requested document cannot be resolved or viewed by the caller, no documents are updated.
     * @summary Bulk edit document classification
     */
    updateBuildingDocumentClassification<
        TData = BulkEditDocumentClassificationResponse,
    >(
        buildingId: string,
        bulkEditDocumentClassificationRequest: BulkEditDocumentClassificationRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingDocumentClassification<
        TData = BulkEditDocumentClassificationResponse,
    >(
        buildingId: string,
        bulkEditDocumentClassificationRequest: BulkEditDocumentClassificationRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingDocumentClassification<
        TData = BulkEditDocumentClassificationResponse,
    >(
        buildingId: string,
        bulkEditDocumentClassificationRequest: BulkEditDocumentClassificationRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingDocumentClassification<
        TData = BulkEditDocumentClassificationResponse,
    >(
        buildingId: string,
        bulkEditDocumentClassificationRequest: BulkEditDocumentClassificationRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.patch<TData>(
                `/@core/api/buildings/${buildingId}/documents/classification`,
                bulkEditDocumentClassificationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.patch<TData>(
                `/@core/api/buildings/${buildingId}/documents/classification`,
                bulkEditDocumentClassificationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.patch<TData>(
            `/@core/api/buildings/${buildingId}/documents/classification`,
            bulkEditDocumentClassificationRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns the building-scoped customer-owned folder hierarchy, visible direct and descendant document counts, breadcrumbs, and the virtual Unfiled count. Customer folders are independent of Quipex taxonomy.
     * @summary Get visible Customer Document Folder tree
     */
    listBuildingDocumentCustomerDocumentFolders<
        TData = CustomerDocumentFolderTreeResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    listBuildingDocumentCustomerDocumentFolders<
        TData = CustomerDocumentFolderTreeResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentCustomerDocumentFolders<
        TData = CustomerDocumentFolderTreeResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentCustomerDocumentFolders<
        TData = CustomerDocumentFolderTreeResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/customer-document-folders`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/customer-document-folders`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/customer-document-folders`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Accepts selected SharePoint, OneDrive, Dropbox, Google Drive, or Procore files/folders and enqueues asynchronous import processing.
     * @summary Import documents from a connected document provider
     */
    createBuildingDocumentImport<TData = DocumentImportAcceptedResponse>(
        buildingId: string,
        documentImportRequest: DocumentImportRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentImport<TData = DocumentImportAcceptedResponse>(
        buildingId: string,
        documentImportRequest: DocumentImportRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentImport<TData = DocumentImportAcceptedResponse>(
        buildingId: string,
        documentImportRequest: DocumentImportRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentImport<TData = DocumentImportAcceptedResponse>(
        buildingId: string,
        documentImportRequest: DocumentImportRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/import`,
                documentImportRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/import`,
                documentImportRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/import`,
            documentImportRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Accepts one or more local ZIP containers within the configured multipart request limit, stages them privately, and enqueues one asynchronous document-import batch. ZIP containers are never persisted as building documents.
     * @summary Import local ZIP archives
     */
    createBuildingDocumentImportLocalArchive<
        TData = DocumentImportAcceptedResponse,
    >(
        buildingId: string,
        localArchiveImportRequest: LocalArchiveImportRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentImportLocalArchive<
        TData = DocumentImportAcceptedResponse,
    >(
        buildingId: string,
        localArchiveImportRequest: LocalArchiveImportRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentImportLocalArchive<
        TData = DocumentImportAcceptedResponse,
    >(
        buildingId: string,
        localArchiveImportRequest: LocalArchiveImportRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentImportLocalArchive<
        TData = DocumentImportAcceptedResponse,
    >(
        buildingId: string,
        localArchiveImportRequest: LocalArchiveImportRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const formData = new FormData();
        localArchiveImportRequest.archives.forEach((value) =>
            formData.append(`archives`, value)
        );

        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/import/local-archives`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/import/local-archives`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/import/local-archives`,
            formData,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Creates a server-side Procore OAuth state and returns the authorization URL for the current user.
     * @summary Start Procore authorization
     */
    createBuildingDocumentProcoreAuthorization<
        TData = StartProcoreAuthorizationResponse,
    >(
        buildingId: string,
        startProcoreAuthorizationRequest: StartProcoreAuthorizationRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentProcoreAuthorization<
        TData = StartProcoreAuthorizationResponse,
    >(
        buildingId: string,
        startProcoreAuthorizationRequest: StartProcoreAuthorizationRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentProcoreAuthorization<
        TData = StartProcoreAuthorizationResponse,
    >(
        buildingId: string,
        startProcoreAuthorizationRequest: StartProcoreAuthorizationRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentProcoreAuthorization<
        TData = StartProcoreAuthorizationResponse,
    >(
        buildingId: string,
        startProcoreAuthorizationRequest: StartProcoreAuthorizationRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/authorization`,
                startProcoreAuthorizationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/authorization`,
                startProcoreAuthorizationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/procore/authorization`,
            startProcoreAuthorizationRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Get current Procore connection
     */
    getBuildingDocumentProcoreConnection<
        TData = ProcoreConnectionStatusResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    getBuildingDocumentProcoreConnection<
        TData = ProcoreConnectionStatusResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentProcoreConnection<
        TData = ProcoreConnectionStatusResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentProcoreConnection<
        TData = ProcoreConnectionStatusResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connection`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connection`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/procore/connection`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary List Procore companies
     */
    listBuildingDocumentProcoreConnectionCompanies<
        TData = ListProcoreCompaniesResponse,
    >(
        buildingId: string,
        connectionId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentProcoreConnectionCompanies<
        TData = ListProcoreCompaniesResponse,
    >(
        buildingId: string,
        connectionId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentProcoreConnectionCompanies<
        TData = ListProcoreCompaniesResponse,
    >(
        buildingId: string,
        connectionId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentProcoreConnectionCompanies<
        TData = ListProcoreCompaniesResponse,
    >(
        buildingId: string,
        connectionId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary List Procore projects
     */
    listBuildingDocumentProcoreConnectionCompanyProjects<
        TData = ListProcoreProjectsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentProcoreConnectionCompanyProjects<
        TData = ListProcoreProjectsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentProcoreConnectionCompanyProjects<
        TData = ListProcoreProjectsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentProcoreConnectionCompanyProjects<
        TData = ListProcoreProjectsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies/${companyId}/projects`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies/${companyId}/projects`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies/${companyId}/projects`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary List Procore project documents
     */
    listBuildingDocumentProcoreConnectionCompanyProjectDocuments<
        TData = ListProcoreDocumentsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        projectId: string,
        params: ListBuildingDocumentProcoreConnectionCompanyProjectDocumentsParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingDocumentProcoreConnectionCompanyProjectDocuments<
        TData = ListProcoreDocumentsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        projectId: string,
        params: ListBuildingDocumentProcoreConnectionCompanyProjectDocumentsParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingDocumentProcoreConnectionCompanyProjectDocuments<
        TData = ListProcoreDocumentsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        projectId: string,
        params: ListBuildingDocumentProcoreConnectionCompanyProjectDocumentsParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingDocumentProcoreConnectionCompanyProjectDocuments<
        TData = ListProcoreDocumentsResponse,
    >(
        buildingId: string,
        connectionId: string,
        companyId: string,
        projectId: string,
        params: ListBuildingDocumentProcoreConnectionCompanyProjectDocumentsParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies/${companyId}/projects/${projectId}/documents`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies/${companyId}/projects/${projectId}/documents`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/procore/connections/${connectionId}/companies/${companyId}/projects/${projectId}/documents`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Search documents within a building. Azure Search supplies a size-bounded candidate window; current database activity, building binding, and role visibility are reapplied before metadata or signed URLs are returned. TotalCount is the visible count in that filtered window and can be lower than Size.
     * @summary Search documents
     */
    searchBuildingDocuments<TData = SearchDocumentsResponse>(
        buildingId: string,
        searchDocumentsRequest: SearchDocumentsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    searchBuildingDocuments<TData = SearchDocumentsResponse>(
        buildingId: string,
        searchDocumentsRequest: SearchDocumentsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    searchBuildingDocuments<TData = SearchDocumentsResponse>(
        buildingId: string,
        searchDocumentsRequest: SearchDocumentsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    searchBuildingDocuments<TData = SearchDocumentsResponse>(
        buildingId: string,
        searchDocumentsRequest: SearchDocumentsRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/search`,
                searchDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/search`,
                searchDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/search`,
            searchDocumentsRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Emails one private message per recipient containing one seven-day, read-only link for each of 1 to 20 selected documents. The complete selection is validated and signed before recipient access or email effects begin.
     * @summary Share selected building documents by email
     */
    bulkShareBuildingDocuments<
        TData = RecipientBatchResponseOfBulkShareBuildingDocumentsResponse,
    >(
        buildingId: string,
        bulkShareBuildingDocumentsRequest: BulkShareBuildingDocumentsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    bulkShareBuildingDocuments<
        TData = RecipientBatchResponseOfBulkShareBuildingDocumentsResponse,
    >(
        buildingId: string,
        bulkShareBuildingDocumentsRequest: BulkShareBuildingDocumentsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    bulkShareBuildingDocuments<
        TData = RecipientBatchResponseOfBulkShareBuildingDocumentsResponse,
    >(
        buildingId: string,
        bulkShareBuildingDocumentsRequest: BulkShareBuildingDocumentsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    bulkShareBuildingDocuments<
        TData = RecipientBatchResponseOfBulkShareBuildingDocumentsResponse,
    >(
        buildingId: string,
        bulkShareBuildingDocumentsRequest: BulkShareBuildingDocumentsRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/share`,
                bulkShareBuildingDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/share`,
                bulkShareBuildingDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/share`,
            bulkShareBuildingDocumentsRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Hard-deletes a document and attempts blob cleanup. Related records are removed via cascade deletes. Documents referenced as ESM evidence cannot be deleted.
     * @summary Delete document
     */
    removeBuildingDocument<TData = void>(
        buildingId: string,
        documentId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingDocument<TData = void>(
        buildingId: string,
        documentId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingDocument<TData = void>(
        buildingId: string,
        documentId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingDocument<TData = void>(
        buildingId: string,
        documentId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Updates a document's category and optional type; folder metadata is derived from the selected category.
     * @summary Edit document classification
     */
    updateBuildingDocument<TData = EditDocumentResponse>(
        buildingId: string,
        documentId: string,
        editDocumentRequest: EditDocumentRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingDocument<TData = EditDocumentResponse>(
        buildingId: string,
        documentId: string,
        editDocumentRequest: EditDocumentRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingDocument<TData = EditDocumentResponse>(
        buildingId: string,
        documentId: string,
        editDocumentRequest: EditDocumentRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingDocument<TData = EditDocumentResponse>(
        buildingId: string,
        documentId: string,
        editDocumentRequest: EditDocumentRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}`,
                editDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}`,
                editDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}`,
            editDocumentRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns typed, source-backed intelligence extracted from the current enrichment snapshot for one accessible building document.
     * @summary Get document intelligence
     */
    getBuildingDocumentIntelligence<TData = GetDocumentIntelligenceResponse>(
        buildingId: string,
        documentId: string,
        params: GetBuildingDocumentIntelligenceParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentIntelligence<TData = GetDocumentIntelligenceResponse>(
        buildingId: string,
        documentId: string,
        params: GetBuildingDocumentIntelligenceParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentIntelligence<TData = GetDocumentIntelligenceResponse>(
        buildingId: string,
        documentId: string,
        params: GetBuildingDocumentIntelligenceParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentIntelligence<TData = GetDocumentIntelligenceResponse>(
        buildingId: string,
        documentId: string,
        params: GetBuildingDocumentIntelligenceParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/intelligence`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/intelligence`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/intelligence`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Marks a building document private or public. Only building owners can update document privacy.
     * @summary Update document privacy
     */
    updateBuildingDocumentPrivacy<TData = UpdateDocumentPrivacyResponse>(
        buildingId: string,
        documentId: string,
        updateDocumentPrivacyRequest: UpdateDocumentPrivacyRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateBuildingDocumentPrivacy<TData = UpdateDocumentPrivacyResponse>(
        buildingId: string,
        documentId: string,
        updateDocumentPrivacyRequest: UpdateDocumentPrivacyRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateBuildingDocumentPrivacy<TData = UpdateDocumentPrivacyResponse>(
        buildingId: string,
        documentId: string,
        updateDocumentPrivacyRequest: UpdateDocumentPrivacyRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateBuildingDocumentPrivacy<TData = UpdateDocumentPrivacyResponse>(
        buildingId: string,
        documentId: string,
        updateDocumentPrivacyRequest: UpdateDocumentPrivacyRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/privacy`,
                updateDocumentPrivacyRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/privacy`,
                updateDocumentPrivacyRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/privacy`,
            updateDocumentPrivacyRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Emails a fixed seven-day read-only signed URL for one document to one to 20 comma-delimited recipients. Building access is only granted or reused when GrantBuildingAccess is true; omitted or false shares only the file. OrganisationAccessPeriod optionally selects Ongoing (default), TwentyFourHours, SevenDays, ThirtyDays, or CustomDays with Days. It applies only to new organisation building access; existing access periods are preserved.
     * @summary Share building document by email
     */
    createBuildingDocumentShare<
        TData = RecipientBatchResponseOfShareBuildingDocumentResponse,
    >(
        buildingId: string,
        documentId: string,
        shareBuildingDocumentRequest: ShareBuildingDocumentRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentShare<
        TData = RecipientBatchResponseOfShareBuildingDocumentResponse,
    >(
        buildingId: string,
        documentId: string,
        shareBuildingDocumentRequest: ShareBuildingDocumentRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentShare<
        TData = RecipientBatchResponseOfShareBuildingDocumentResponse,
    >(
        buildingId: string,
        documentId: string,
        shareBuildingDocumentRequest: ShareBuildingDocumentRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentShare<
        TData = RecipientBatchResponseOfShareBuildingDocumentResponse,
    >(
        buildingId: string,
        documentId: string,
        shareBuildingDocumentRequest: ShareBuildingDocumentRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/share`,
                shareBuildingDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/share`,
                shareBuildingDocumentRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/share`,
            shareBuildingDocumentRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns a fixed seven-day, read-only signed URL for one accessible building document.
     * @summary Create document share link
     */
    createBuildingDocumentShareLink<TData = CreateDocumentShareLinkResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingDocumentShareLink<TData = CreateDocumentShareLinkResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingDocumentShareLink<TData = CreateDocumentShareLinkResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingDocumentShareLink<TData = CreateDocumentShareLinkResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/share-link`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/share-link`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/share-link`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns a fresh signed read URL for one accessible building document.
     * @summary Get document view URL
     */
    getBuildingDocumentViewUrl<TData = GetDocumentViewUrlResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getBuildingDocumentViewUrl<TData = GetDocumentViewUrlResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getBuildingDocumentViewUrl<TData = GetDocumentViewUrlResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getBuildingDocumentViewUrl<TData = GetDocumentViewUrlResponse>(
        buildingId: string,
        documentId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/view-url`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/documents/${documentId}/view-url`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/documents/${documentId}/view-url`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Queues the exact authorized request-time nonempty selection of distinct document IDs within the shared configured async ZIP file-count and byte limits. Null, empty, duplicate, inactive, inaccessible or foreign-building selections are rejected in full. The selection never falls back to export-all.
     * @summary Start a selected building document export
     */
    createBuildingSelectedDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        startSelectedDocumentExportRequest: StartSelectedDocumentExportRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingSelectedDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        startSelectedDocumentExportRequest: StartSelectedDocumentExportRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingSelectedDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        startSelectedDocumentExportRequest: StartSelectedDocumentExportRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingSelectedDocumentExport<TData = StartDocumentExportResponse>(
        buildingId: string,
        startSelectedDocumentExportRequest: StartSelectedDocumentExportRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/selected-document-exports`,
                startSelectedDocumentExportRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/selected-document-exports`,
                startSelectedDocumentExportRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/selected-document-exports`,
            startSelectedDocumentExportRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Receives the Procore OAuth callback, stores the server-side connection, and posts completion to the opener window.
     * @summary Complete Procore authorization callback
     */
    getProcoreOauthCallback<TData = void>(
        params?: GetProcoreOauthCallbackParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getProcoreOauthCallback<TData = void>(
        params?: GetProcoreOauthCallbackParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getProcoreOauthCallback<TData = void>(
        params?: GetProcoreOauthCallbackParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getProcoreOauthCallback<TData = void>(
        params?: GetProcoreOauthCallbackParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(`/@core/api/procore/oauth/callback`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'events',
                params: filteredParams,
            });
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(`/@core/api/procore/oauth/callback`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'response',
                params: filteredParams,
            });
        }

        return this.http.get<TData>(`/@core/api/procore/oauth/callback`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
            params: filteredParams,
        });
    }
}
